import type { Country, Locale } from '@/types/regionTypes';

import type { LanguageCodeEnum, Money } from '@/graphql/saleor/api';
import { createSafeContext } from '@/lib/context';
import type { CURRENCY_DISPLAY } from '@/lib/intl';
import type { Maybe } from '@/lib/types';

export type RegionsProviderContext = {
  changeCountry: (code: string, locale: string) => Promise<void>;
  country: Country;
  formatDate: (date: string) => string;
  formatDateTime: (dateTime: string) => string;
  formatPrice: (
    price: Maybe<Pick<Money, 'amount' | 'currency'>>,
    opts?: {
      currencyDisplay?: CURRENCY_DISPLAY;
      maximumFractionDigits?: number;
    },
  ) => JSX.Element;
  formatPriceString: (
    price: Maybe<Partial<Pick<Money, 'amount' | 'currency'>>>,
    opts?: {
      currencyDisplay?: CURRENCY_DISPLAY;
      maximumFractionDigits?: number;
    },
  ) => string;
  locale: Locale;
  productCatalogMode: boolean;
  query: {
    channel: string;
    languageCode: LanguageCodeEnum;
  };
  shouldIncludeVAT: boolean;
  supportedCountries: Country[];
  unit: 'mm' | 'inch';
};
export const { Provider, useContext: useRegionProvider } =
  createSafeContext<RegionsProviderContext>(
    'useRegionProvider must be used inside a RegionProvider',
  );
